/**
 * Every entity field the app knows, by name.
 *
 * The authority for the key set. `FIELD_LABELS` (German) and the frontend's
 * icon table are exhaustive over it, so adding a field fails the build in
 * whichever has not caught up. `FIELD_FORMAT` is partial by design — a field
 * with no entry simply has no unit and no fixed precision — the
 * direction every other contract here runs, where structure is the authority
 * and the German has to be exhaustive over it.
 */
export const FIELD_KEYS = [
  'livingArea',
  'usableArea',
  'landArea',
  'gardenArea',
  'balconyArea',
  'wallArea',
  'numberOfRooms',
  'numberOfBathrooms',
  'numberOfFloors',
  'numberOfIndoorParkingSpaces',
  'numberOfOutdoorParkingSpaces',
  'floorNumber',
  'createdAt',
  'updatedAt',
  'lastSeenAt',
  'constructionYear',
  'renovationYear',
  'energyLabel',
  'energyConsumption',
  'marketPrice',
  'potentialPrice',
  'leasehold',
  'isNew',
  'type',
  'subType',
  'email',
  'title',
  'name',
  'lastName',
  'firstName',
  'salutation',
  'academicTitle',
  'customerNumber',
  'userType',
  'phoneType',
  'note',
  'roles',
  'status',
  'configuratorStatus',
  'notes',
  'description',
  'serviceDescription',
  'customerHint',
  'icon',
  'address',
  'street',
  'houseNumber',
  'postalCode',
  'city',
  'district',
  'contactPerson',
  'projectManager',
  'siteManager',
  'customer',
  'phone',
  'gender',
  'jobTitle',
  'calendarBookingUrl',
  'roomType',
  'productStandard',
  'productCategory',
  'productGroup',
  'designLine',
  'collection',
  'isActive',
  'floor',
  'length',
  'width',
  'height',
  'perimeter',
  'area',
  'flatRateCost',
  'quantity',
  'rowCount',
  'unit',
  // Finances
  'netAmount',
  'grossAmount',
  'vatRate',
  'percent',
  'amount',
  'invoiceNumber',
  'invoiceDate',
  'dueDate',
  'paidAt',
  'approvedAt',
  'signedAt',
  'reachedAt',
  'paymentTermDays',
  'iban',
  'reference',
  'contactName',
] as const

export type FieldKey = (typeof FIELD_KEYS)[number]
